module.exports = __webpack_public_path__ + "static/media/pause.595cbc7c.svg";